import { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import TaxonomyCodeIcon from "../../../assets/images/svg-icons-material-io/link_FILL0_wght400_GRAD0_opsz48.svg";
import MonitorIcon from "../../../assets/images/svg-icons-material-io/screenshot_monitor_FILL0_wght400_GRAD0_opsz48.svg";
import CallAPI from "../../../services/apiCalls";
import useUserStore from "../../../utils/storeApp";
import $ from "jquery";
import fileDownload from "js-file-download";
import OrgEmailBulkUploadTemplate from "./../../../assets/images/OrgEmailbulkUploadimg.JPG";
import CreateFilenameModal from "../../upload-status/CreateFilenameModal";
import { UploadType } from "../../../utils/enums";

const obj = {
  VendorId: 0,
  OrganizationId: 0,
  OrganizationName: "",
  UserSubmitFile: "",
};

const UploadOrgEmailForm = () => {
  const { userToken, sharedObject, SetSharedObject, userRole, userSession } =
    useUserStore((state) => ({
      userToken: state.userToken,
      SetSharedObject: state.SetSharedObject,
      sharedObject: state.sharedObject,
      userRole: state.userRole,
      userSession: state.userSession,
    }));
  const [processing, SetProcessing] = useState(false);
  const [submitFlag, SetSubmitFlag] = useState(false);
  const [errFlag, SetErrFlag] = useState(false);
  const [answers, setAnswers] = useState(obj);
  const [custObject, SetCustObject] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [uploadType, setUploadType] = useState("Add");

  const statusRef = useRef(null);

  useEffect(() => {
    const temp = [];
    for (let el of sharedObject.vendorsObj) {
      el.show = true;
      temp.push(el);
    }
    SetCustObject(temp);
    SetSharedObject("specialties", {});
    SetSubmitFlag(false);
  }, []);

  const setAnswer = async (questionId, answer, chck) => {
    if (questionId === "UploadOption") {
      await setUploadType(answer);
    }
    await setAnswers({ ...answers, [questionId]: answer });
  };
  const filterVendors = (val) => {
    const tmp = [];
    if (val.length > 1) {
      custObject?.map((el) => {
        let elem = el.name;
        if (elem.toLowerCase().includes(val.toLowerCase())) {
          el.show = true;
        } else {
          el.show = false;
        }
        tmp.push(el);
      });
    } else {
      custObject?.map((el) => {
        el.show = true;
        tmp.push(el);
      });
    }
    SetCustObject(tmp);
  };
  const downTemplate = async (url) => {
    SetProcessing(true);
    if (statusRef.current) statusRef.current.textContent = "Downloading template�";
    const res = await CallAPI(url, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      let fileName = "OrgEmailUploadtemplate.csv";
      fileDownload(res.data, fileName);
      SetProcessing(false);
    } else if (res.status === "SERVERERROR") {
      SetProcessing(false);
    }
  };

  const initiateUpload = () => {
    const fileInput = document.querySelector('input[type="file"]');
    const file = fileInput.files[0];
    let vId = answers.VendorId === 0 ? userSession.vendor_id : answers.VendorId;
    let o = {
      UploadType: UploadType.AddOrganizationEmails,
      UploadFile: file,
      VendorId: vId,
      UploadOption: answers.UploadOption,
    };
    SetSharedObject("UploadStausObj", o);
  };
  const triggerValidation = (el) => {
    var regex = /\.csv$/i;
    if (!regex.test(el.target.value.toLowerCase())) {
      SetErrFlag(true);
    } else {
      setAnswer("UserSubmitFile", el);
      SetErrFlag(false);
    }
  };
  const getDomain = (url) => {
    url = url.replace(/(https?:\/\/)?(www.)?/i, "");
    if (url.indexOf("/") !== -1) {
      return url.split("/")[0];
    }
    return url;
  };
  const openImg = () => {
    let url = getDomain(window.location.hostname);
    if (url === "localhost") {
      window.open(OrgEmailBulkUploadTemplate);
    } else {
      window.open(OrgEmailBulkUploadTemplate);
    }
  };

  const disableEnter = async (el) => {
    if (el.keyCode === 13 || el.which === 13) {
      el.preventDefault();
      return false;
    }
  };

  const [loadingText, setLoadingText] = useState("Loading...");
  useEffect(() => {
    let timer;
    if (processing) {
      timer = setTimeout(() => {
        setLoadingText("Working on it...");
      }, 10000);
    } else {
      setLoadingText("Loading...");
    }

    return () => clearTimeout(timer);
  }, [processing]);

  return (
    <div className="UploadOrgEmailForm">
       <div
        ref={statusRef}
        role="status"
        aria-live="polite"
        aria-atomic="true"
        className="sr-only"
      />
      <form className="sp-pad1" aria-labelledby="form-heading" noValidate>
      <h2 id="form-heading" className="sr-only">
          Upload Organization Email
        </h2>
        {/*Left Panel*/}
        <div className="left-panel-s1">
          {userRole !== "SES ADMINISTRATOR" &&
          userRole !== "SYSTEMADMINISTRATOR" ? null : (
            <div className="field-wrapper">
              <label htmlFor="VendorId">Customer</label>
              <span className="filter-container dg-clr">
              <label htmlFor="vendor-filter" className="sr-only">
                  Filter customers
                </label>
                <input
                  id="vendor-filter"
                  className="form-control filter-sm"
                  type="search"
                  placeholder="Filter"
                  aria-controls="VendorId"
                  onChange={(el) => {
                    filterVendors(el.target.value);
                  }}
                  onKeyDown={(el) => {
                    disableEnter(el);
                  }}
                />
              </span>
              <select
                className="form-control"
                size="4"
                id="VendorId"
                name="VendorId"
                onChange={(el) => {
                  setAnswer("VendorId", parseInt(el.target.value));
                }}
                value={answers?.VendorId}
                aria-required="true"
                aria-describedby={submitFlag && answers?.VendorId === 0 ? "vendor-error" : undefined}
                aria-invalid={submitFlag && answers?.VendorId === 0 ? "true" : "false"}
              >
                <option value={0}>Select Customer</option>
                {custObject?.map((el) => {
                  if (el.show)
                    return (
                      <option key={el.id} value={el.id}>
                        {el.name}
                      </option>
                    );
                })}
              </select>
              {submitFlag && answers?.VendorId === 0 ? (
                <div 
                    className="alert alert-danger" 
                    id="vendor-error" 
                    role="alert" 
                    aria-live="assertive" 
                    aria-atomic="true"
                >
                    Customer is required.
               </div>
              ) : null}
            </div>
          )}
          <div className="field-wrapper">
            <label htmlFor="UploadOption" className="spacer-margin5">
              Do you want to add or delete emails?
            </label>
            <select
              className="form-control w-lg4 spacer-inline"
              id="UploadOption"
              name="UploadOption"
              onChange={(el) => {
                setAnswer("UploadOption", el.target.value);
              }}
              value={answers?.UploadOption}
            >
              <option value="Add">Add</option>
              <option value="Delete">Delete</option>
            </select>
          </div>
          <div className="field-wrapper">
            <label htmlFor="UserSubmitFile">Select CSV file</label>
            <div className="form-group">
              <input
                type="file"
                className="form-control-file  cblu-clr "
                id="UserSubmitFile"
                name="UserSubmitFile"
                accept=".csv"
                aria-required="true"
                aria-describedby="file-hint file-error"
                aria-invalid={errFlag || (answers?.UserSubmitFile === "" && submitFlag) ? "true" : "false"}
                onChange={(el) => {
                  triggerValidation(el);
                }}
              />
              {answers?.UserSubmitFile === "" && submitFlag ? (
                <div id="file-error" className="alert alert-danger" role="alert" aria-live="assertive" aria-atomic="true">CSV file is required.</div>
              ) : null}
            </div>
            {errFlag ? (
              <div id="file-error" className="alert alert-danger" role="alert" aria-live="assertive" aria-atomic="true">
                The file you are trying to upload is not a CSV file. Please try
                again using a proper file type with a .csv file extension. You
                can also download our template and view our sample below.
              </div>
            ) : null}
            <aside className="filelist-items" id="file-hint">
              The MS Excel spreadsheet must be saved as a CSV format that
              contains a .csv extension and rename the file if you intend to
              upload it again.
            </aside>
          </div>
          
            {processing && (
                <div 
                    className="loader-container" 
                    role="status" 
                    aria-live="polite" 
                    aria-atomic="true"
                    aria-labelledby="loader-id"
                >
                    <div className="spinner" aria-hidden="true"></div>
                    <div className="loading-text" id="loader-id">{loadingText}</div>
             </div>
            )}
        

          {/*Upload Action*/}
          <div className="button-register-container">
            <button
              type="button"
              className="btn btn-success"
              disabled={errFlag}
              aria-disabled={errFlag ? "true" : undefined}
              onClick={() => {
                SetSubmitFlag(true);
                /*if (answers?.VendorId !== 0 && answers?.UserSubmitFile !== "")*/
                if (answers?.UserSubmitFile !== "") {
                  if (answers?.UploadOption === "Delete") {
                    setShowDeleteModal(true);
                  } else {
                    initiateUpload();
                    $("#createFilenameModal").modal("show");
                  }
                }
              }}
            >
              Upload
            </button>

            <Link
              className="btn btn-outline-secondary spacer-margin2"
              to="/Organizations"
            >
              Cancel
            </Link>
          </div>

          {/*Templates*/}
          <nav className="box-template" aria-label="Resources and templates">
            <button
              type="button"
              onClick={(el) => {
                downTemplate(
                  "/organization/DownloadCsvTemplate?csv=OrgEmailUploadtemplate"
                );
                el.preventDefault();
              }}
              className="btn btn-primary box-containers box-sentmsg"
              aria-label="Download CSV file template"
            >
              <div className="box-icon" aria-hidden="true">
                <i className="bi bi-download"></i>
              </div>
              <div className="box-bottom">
                <div className="title" aria-hidden="true">CSV File Template</div>
              </div>
            </button>
            <a
              href="https://www.nucc.org/index.php?option=com_content&view=article&id=107&Itemid=132"
              target="_blank"
              className="btn btn-primary box-containers box-status"
              rel="noreferrer noopener"
              aria-label="NUCC Taxonomy Codes (opens in a new tab)"
            >
              <div className="box-icon" aria-hidden="true">
                <img
                  src={TaxonomyCodeIcon}
                  className="filter-white"
                  alt=""
                />
              </div>
              <div className="box-bottom">
                <div className="title" aria-hidden="true">NUCC Taxonomy Codes</div>
              </div>
            </a>

            <button
              // to={OrgEmailBulkUploadTemplate}
              onClick={openImg}
              target="_blank"
              className="btn btn-primary box-containers box-reports"
              aria-label="View sample CSV file screenshots (opens in a new tab)"
            >
              <div className="box-icon" aria-hidden="true">
                <img
                  src={MonitorIcon}
                  className="filter-white"
                  alt=""
                />
              </div>
              <div className="box-bottom">
                <div className="title" aria-hidden="true">
                  Sample <br />
                  CSV File Screenshots
                </div>
              </div>
            </button>
          </nav>
        </div>

        {/*Right Panel*/}
        <div className="right-panel-s1">
            {/*Requirement Rules*/}
            <section aria-labelledby="requirements-heading">
                <h5 id="requirements-heading" className="field-wrapper label-hd-divider">
                    Requirements
                </h5>
                <div className="field-wrapper">
                {uploadType === "Add" ? (
                  <>
                    <p className="text-reg spacer-margin7">
                      The following list of items are required and must be included
                      in your file.
                    </p>
                    <ul className="filelist-items">
                      <li>
                        <span className="ft-wt blk-clr">External ID:</span>{" "}
                        Organization ID
                      </li>
                      <li>
                        <span className="ft-wt blk-clr">Email Purpose:</span> Select
                        one
                        <ul>
                          <li>General</li>
                          <li>For only XML Medical Records enter MedicalRecordsXMLonly</li>
                          <li>For Medical Records enter MedicalRecords</li>
                          <li>Administrative</li>
                        </ul>
                      </li>
                      <li>
                        <span className="ft-wt blk-clr">
                          Requested Org Direct Email:
                        </span>
                        <ul>
                          <li>Enter only the email name without the domain.</li>
                          <li>Domains will be added according to the organization.</li>
                        </ul>
                      </li>
                    </ul>
                  </>
                ) : (
                  <>
                    <p className="text-reg spacer-margin7">
                      The following steps are required to delete emails
                      successfully.
                    </p>
                    <ul className="filelist-items">
                      <li>Use the same org email template</li>
                      <li>Enter Direct email address only</li>
                      <li>Upload with a different filename</li>
                    </ul>
                  </>
                )}
            </div>
          </section>
          </div>
      </form>
      <CreateFilenameModal />
      <DeleteConfirmationModal
        show={showDeleteModal}
        onConfirm={() => {
          setShowDeleteModal(false);
          initiateUpload();
          $("#createFilenameModal").modal("show");
        }}
        onCancel={() => setShowDeleteModal(false)}
      />
    </div>
  );
};

const DeleteConfirmationModal = ({ show, onConfirm, onCancel }) => {
  const [visible, setVisible] = useState(show);
  const firstFocusRef = useRef(null);
  const previousFocusRef = useRef(null);

  useEffect(() => {
    if (show) {
      setVisible(true);
      previousFocusRef.current = document.activeElement;
      setTimeout(() => firstFocusRef.current?.focus(), 50);
    } else {
        const timeout = setTimeout(() => {
            setVisible(false);
            previousFocusRef.current?.focus();
        }, 150);
      return () => clearTimeout(timeout);
    }
  }, [show]);

  // Accessibilty: so users cannot use keyboard to tab out of the modal
  const handleKeyDown = (e) => {
    if (e.key === "Escape") {
      onCancel();
      return;
    }
    if (e.key !== "Tab") return;

    const modal = e.currentTarget;
    const focusable = modal.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (e.shiftKey) {
      if (document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  };


  if (!visible) return null;

  const CloseModal = () => {
    if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
    }

      $('#UploadOrgEmailDeleteConfirmModal').modal('hide');
};

  return (
    <>
      <div
        className={`modal fade ${show ? "show" : ""}`}
        id="UploadOrgEmailDeleteConfirmModal"
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
        aria-labelledby="delete-modal-title"
        aria-describedby="delete-modal-body"
        style={{ display: show ? "block" : "none" }}
        data-backdrop="static"
        onKeyDown={handleKeyDown}
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="modal-title" id="delete-modal-title">
                Delete Confirmation
              </h3>
              <button
                type="button"
                className="close"
                aria-label="Close delete confirmation dialog"
                onClick={()=> {
                    onCancel();
                    CloseModal();
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body" id="delete-modal-body">
              <div className="alert-warning-o" aria-hidden="true">
                <i className="bi bi-exclamation-circle"></i>
              </div>

              <div className="message-wrapper">
                Are you sure you want to permanently delete all the emails?
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-success" onClick={onConfirm} ref={firstFocusRef}>
                Confirm
              </button>
              <button 
                className="btn btn-outline-secondary" 
                onClick={()=> {
                    onCancel();
                    CloseModal();
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
      <div 
        className={`modal-backdrop fade ${show ? "show" : ""}`}
        aria-hidden="true"
      />
    </>
  );
};
export default UploadOrgEmailForm;
